module.exports = "pegasus/assets/hexline-linkedin.gif";